import styled from '@emotion/styled';
import { Button, colors, Stack } from '@ui-components/neo.tax';

export const StyledButton = styled(Button)({
  margin: 0,
  justifyContent: 'space-between',
});

export const DeleteButton = styled(StyledButton)({
  width: 'fit-content',
});

export const ResendButton = styled(StyledButton)({
  width: 'fit-content',
});

export const BottomStack = styled(Stack)({
  borderTop: `1px solid ${colors.gray[200]}`,
});
